import { farasod } from "./api"

const endpoint = "/snapbox"

export const snapboxOtp = async data => {
  const response = await farasod.post(`${endpoint}/otp`, data)

  return response.data
}

export const snapboxOtpConfirm = async (data) => {
  const response = await farasod.post(`${endpoint}/otp/confirm`, data)

  return response.data
}

export const getSnapboxWallet = async (branchId) => {
  const response = await farasod.get(`${endpoint}/balance/${branchId}`)

  return response.data
}

export const getSnapboxBalance = async (branchId) => {
  const response = await farasod.get(`${endpoint}/wallet/${branchId}`)

  return response.data
}

export const getSnapboxProfile = async (branchId) => {
  const response = await farasod.get(`${endpoint}/profile/${branchId}`)

  return response.data
}

export const snapboxLogout = async (branchId) => {
  const response = await farasod.post(`${endpoint}/logout/${branchId}`)

  return response.data
}